import React from 'react';
import { StudentLoginPage_1, StudentHomePage_2 } from '../static'

const OnlinePayment = () => {
    return (
        <div className='onlinePayment'>
            <div className='card'>
                <div className="card-header">
                    <p className='allText'>Featured</p>
                </div>
                <img className='card-img-top' src={StudentLoginPage_1} alt={StudentLoginPage_1} />
            </div>
            <div className='card'>
                <div className="card-header">
                    <p className='allText'>Featured</p>
                </div>
                <img className='card-img-top' src={StudentHomePage_2} alt={StudentLoginPage_1} />
            </div>
        </div>
    );
};

export default OnlinePayment;